import { InjectionToken } from '@angular/core';
import { StoragePort } from '@platform/storage/domain/ports/storage.port';
import { PermissionState } from '@features/permission/application/stores/permission.store';

export const PERMISSION_STORE_STORAGE = new InjectionToken<StoragePort<PermissionState>>('PERMISSION_STORE_STORAGE');
